module.exports = __webpack_public_path__ + "static/media/mushroom-land1.acbd39f2.gif";